import { Button, Typography } from '@mui/material'
import { useRouter } from 'next/router'
import LazyImg from '../img/lazyImg'
import { statsigLog } from '../../lib/statsigAndGa'

const ToResearch = ({ className = '', priority = false }) => {
  const router = useRouter()

  const gotoSearch = () => {
    statsigLog('start_your_search_click')
    router.push('/')
  }

  return (
    <div
      className={`${className} mt-15 md:mt-20 relative flex items-center justify-center h-52 lg:h-80`}
    >
      <div className="text-center px-5 w-full relative z-[2]">
        <div className="text-white mb-6 font-ramaraja text-[32px] leading-none md:text-[64px]">
          Start your research with Renty.AI
        </div>
        <Button
          className="py-3 px-7 rounded-xl bg-brand shadow-none capitalize"
          onClick={gotoSearch}
          style={{ border: '3px solid rgba(176,198,170,0.4)' }}
        >
          <Typography className="font-semibold text-base text-white">Start Your Search</Typography>
        </Button>
      </div>
      <div className="absolute inset-0 z-[0]">
        <LazyImg
          url={`${process.env.CDN_PREFIX}/web/572770c0d95291fb.jpg`}
          useCurrentUrl
          priority={priority}
          className="object-cover"
        />
      </div>
      <div
        className="absolute inset-0 z-[1]"
        style={{ background: 'linear-gradient(180deg, rgba(5, 10, 34, 0.00) 0%, #050A22 100%)' }}
      />
    </div>
  )
}

export default ToResearch
